import { handleActions } from 'redux-actions'

import { actions } from '../actions/users'

const defaultState = {
    userTokens: {
        accessToken: {
            token: undefined,
            expiresAt: undefined
        },
        idToken: {
            token: undefined, 
            expiresAt: undefined
        }
    }
}

const resetUser = (_state, _action) => {
    return defaultState
}

const setUserTokens = (state, action) => {
    return { ...state, userTokens: action.payload }
}

export default handleActions({
    [actions.resetUser]: resetUser,
    [actions.setUserTokens]: setUserTokens
}, defaultState)



// WEBPACK FOOTER //
// ./src/store/reducers/users.js